import { render, staticRenderFns } from "./CatalogCartSider.vue?vue&type=template&id=7d9840a7&scoped=true&lang=pug"
import script from "./CatalogCartSider.vue?vue&type=script&lang=js"
export * from "./CatalogCartSider.vue?vue&type=script&lang=js"
import style0 from "./CatalogCartSider.vue?vue&type=style&index=0&id=7d9840a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9840a7",
  null
  
)

export default component.exports